import { FC } from 'react';
import { Card, Col, Grid, Image, Row, Typography } from 'antd';
import { formatDateListArticels, formatDateListArticelsMobile } from 'src/utils/func/format-date';
import classes from './article.module.less';
interface CardArticleInterface {
  data?: any;
}
const CardWeb = (item: any) => {
  const items = item.item;
  const dataPhase = items.type === 'pregnancy' ? 'kehamilan' : items.type === 'pre-pregnancy' ? 'pra-kehamilan' : 'pasca-kehamilan';
  return <a href={`/${dataPhase}/${items.slug}`}>
			<Card key={item.item.id} size="small" hoverable={false} className={classes.cardsWeb} style={{
      cursor: 'pointer',
      width: '500px'
    }}>
				<Row>
					<Col span={14}>
						<Image alt={item.item.title} src={item.item.media_images.original} className={classes.imageContainer} style={{
            borderRadius: '20px',
            objectFit: 'cover'
          }} preview={false} loading='lazy' width={252} height={140} />
					</Col>
					<Col span={10}>
						<div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            height: '140px',
            // width: '100%',
            // padding: '16px',
            marginLeft: '16px',
            boxSizing: 'border-box'
          }}>
							<Typography className={classes.category}>
								{item.item.category_name}
							</Typography>
							<Typography className={classes.title} style={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              width: '100%',
              lineHeight: 1.2,
              maxHeight: '2 em'
            }}>
								{item.item.title}
							</Typography>
							<Typography className="fs-11 fs-md-13" style={{
              marginLeft: '-10px'
            }}>
								Diterbitkan pada {formatDateListArticels(item.item.publish_date)}
							</Typography>
							<Typography className="fs-12 fs-md-14" style={{
              color: '#9ca3aa',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
              display: 'block',
              marginLeft: '-10px'
            }}>
								{item.item.short_desc}
							</Typography>
						</div>
					</Col>
				</Row>
			</Card>
		</a>;
};
const CardArticleHBSection2: FC<CardArticleInterface> = props => {
  const oriArray = props.data;
  const {
    xs
  } = Grid.useBreakpoint();
  return <div className={classes.containerCard}>
			<Row>
				{xs ? oriArray.slice(1, 4).map((item: any) => {
        const dataPhase = item.type === 'pregnancy' ? 'kehamilan' : item.type === 'pre-pregnancy' ? 'pra-kehamilan' : 'pasca-kehamilan';
        return <Col sm={8} md={8} lg={8} xl={8} xs={24} key={item.uid}>
									<a href={`/${dataPhase}/${item.slug}`}>
										<span>
											<Card key={item.id} size="small" hoverable={false} className={`${classes.cards} ${classes.noPaddingCard}`} style={{
                cursor: 'pointer',
                marginLeft: '-12px',
                marginRight: '-12px',
                padding: 0
              }}>
												<Row>
													<Col xs={11}>
														<Image alt={item.title} src={item.media_images.original} className={classes.imageContainer} style={{
                      borderRadius: xs ? '8px' : '14px',
                      objectFit: 'cover'
                    }} preview={false} loading='lazy' width={135} height={73} />
													</Col>
													<Col xs={13}>
														<div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                      height: '73px',
                      boxSizing: 'border-box'
                    }}>
															<Typography className={classes.category} style={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        lineHeight: 1,
                        maxHeight: '2 em'
                      }}>
																{item.category_name}
															</Typography>
															<Typography className={classes.title} style={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        lineHeight: 1.2,
                        maxHeight: '2 em'
                      }}>
																{item.title}
															</Typography>
															<Typography className="fs-11 fs-md-12" style={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        lineHeight: 1,
                        maxHeight: '2 em',
                        marginLeft: '-9px'
                      }}>
																Diterbitkan pada {formatDateListArticelsMobile(item.publish_date)}
															</Typography>
															{/* <Typography
                className="fs-12 fs-md-14"
                style={{
                color: '#9ca3aa',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '80%',
                display: 'block',
                marginLeft: '-10px',
                }}>
                {item.short_desc}
                </Typography> */}
														</div>
													</Col>
												</Row>
											</Card>
										</span>
									</a>
								</Col>;
      }) : oriArray.slice(1, 4)?.map((item: any) => {
        return <CardWeb key={item.id} item={item} />;
      })}
			</Row>
		</div>;
};
export default CardArticleHBSection2;